import React from "react";
import { FaRedo, FaSave } from "react-icons/fa";

export default function SaveSettingsBar({
  saving,
  loading,
  hasUnsavedChanges,
  onSave,
  onReset,
}) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-slate-200 bg-white/90 px-4 py-3 backdrop-blur dark:border-slate-800 dark:bg-slate-950/90 lg:left-20">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-sm font-bold text-slate-950 dark:text-white">
            {hasUnsavedChanges
              ? "Modifications non enregistrées"
              : "Paramètres à jour"}
          </p>

          <p className="text-xs text-slate-500 dark:text-slate-400">
            Pensez à enregistrer après avoir modifié les paramètres.
          </p>
        </div>

        <div className="flex flex-col-reverse gap-2 sm:flex-row">
          <button
            type="button"
            onClick={onReset}
            disabled={saving || loading || !hasUnsavedChanges}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            <FaRedo />
            Annuler les changements
          </button>

          <button
            type="button"
            onClick={onSave}
            disabled={saving || loading || !hasUnsavedChanges}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-950 px-4 py-3 text-sm font-bold text-white shadow-lg shadow-slate-950/20 transition hover:-translate-y-0.5 hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-white dark:text-slate-950 dark:hover:bg-slate-200"
          >
            <FaSave />
            {saving ? "Enregistrement..." : "Enregistrer"}
          </button>
        </div>
      </div>
    </div>
  );
}